import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBreakfast: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBreakfast"><Path d="M21.5 12.2064C21.5 17.5671 21.3102 22.1712 14.7739 20.4397C12.7044 19.8915 10.2844 21.6041 8.56526 21.495C0.22219 20.9657 0.11465 2.4999 10.5678 2.5C16.4641 2.50006 14.8043 5.36742 16.4641 7.35318C17.8994 9.07042 21.5 7.35318 21.5 12.2064Z" stroke="currentColor"/><Circle cx="11" cy="13" r="3.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconBreakfast;
